module.exports = __webpack_public_path__ + "media/application/images/playbook-blue-card-bg-ff9240bc71d7529d3cb8f53ceb127ffc.png";